import React from 'react';
import { Truck, ShieldCheck, Headphones, RotateCcw } from 'lucide-react';
import { motion } from 'framer-motion';
const features = [{
  icon: Truck,
  title: 'FREE SHIPPING',
  description: 'On orders over $1,299'
}, {
  icon: ShieldCheck,
  title: 'WARRANTY',
  description: 'Industry-leading coverage'
}, {
  icon: Headphones,
  title: 'EXPERT SUPPORT',
  description: 'Call us Mon-Fri 8am-5pm'
}, {
  icon: RotateCcw,
  title: 'EASY RETURNS',
  description: '30-day hassle-free returns'
}];
export function TrustBadges() {
  return <section className="w-full bg-charcoal py-20 border-t border-gray-800 relative overflow-hidden" data-id="element-202">
      {/* Metallic sheen background effect */}
      <div className="absolute inset-0 bg-gradient-to-b from-white/5 to-transparent pointer-events-none" data-id="element-203"></div>

      <div className="max-w-[1400px] mx-auto px-4 lg:px-8 relative z-10" data-id="element-204">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-12 text-center" data-id="element-205">
          {features.map((feature, index) => <motion.div key={feature.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="flex flex-col items-center group" data-id="element-206">
              <div className="mb-6 p-4 border-2 border-gray-700 group-hover:border-primary transition-colors skew-x-[-10deg]" data-id="element-207">
                <div className="skew-x-[10deg]" data-id="element-208">
                  <feature.icon className="w-10 h-10 text-chrome group-hover:text-primary transition-colors duration-300" data-id="element-209" />
                </div>
              </div>
              <h3 className="text-2xl font-heading font-bold text-white uppercase italic tracking-wider mb-2" data-id="element-210">
                {feature.title}
              </h3>
              <p className="text-gray-400 font-sans text-sm" data-id="element-211">
                {feature.description}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}